"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _cccisdValidator = _interopRequireDefault(require("cccisd-validator"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(values, formProps) {
  var fieldTypes = formProps.fieldTypes;
  var errors = {};
  var validationSettings = {};
  for (var _i = 0, _Object$keys = Object.keys(fieldTypes); _i < _Object$keys.length; _i++) {
    var field = _Object$keys[_i];
    var _fieldTypes$field = fieldTypes[field],
      fvs = _fieldTypes$field.validationSettings,
      displaySettings = _fieldTypes$field.displaySettings;
    if (!fvs || displaySettings && displaySettings.renderAs === 'jsonArray' && !fvs.isRequired) {
      continue;
    }
    var fvalue = values[field];
    if (fvalue) {
      // jsonArray validates each individual value in the Component
      // only do isRequired validation here
      if (displaySettings && displaySettings.renderAs === 'jsonArray') {
        // eslint-disable-next-line no-useless-escape
        if (fvalue.replace(/[\[\]]/g, '').length === 0) {
          errors[field] = 'This field is required.';
        }
        continue;
      }
      validationSettings.min = fvs.min || (fvs.isRequired ? '1' : '0');
      validationSettings.max = fvs.max || '255';
      validationSettings.types = fvs.validationType ? [fvs.validationType] : [];
      validationSettings.regex = fvs.regex || '';
      if (validationSettings.types.includes('regex') && !validationSettings.regex) {
        console.error('validationSettings have type of `regex`, but no `regex` key is provided');
      }
      var _validator = (0, _cccisdValidator["default"])(fvalue, validationSettings),
        vStatus = _validator.status,
        vErrors = _validator.errors;
      if (vStatus === 'fail') {
        errors[field] = fvs.validationMessage || vErrors[Object.keys(vErrors)[0]];
      }
    }
    var isEmpty = (0, _isEmpty2["default"])(fvalue) && !(fvalue instanceof Date) && !Number.isFinite(fvalue);
    if (fvs.isRequired && (isEmpty || fvalue === '&nbsp;')) {
      errors[field] = 'This field is required.';
    }
  }
  return errors;
};